<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :seq-config="{
      startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
    }"
    :toolbar-config="tableToolbar"
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:pager>
      <slot name="pager"></slot>
    </template>
    <template v-slot:opt="{row}">
      <div>
        <el-tooltip
          class="item"
          effect="dark"
          v-if="allow('D')"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-show="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            @click="del(row.goodsSpecFabriclCode)"
          ></i>
        </el-tooltip>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      type: Object,
      default: () => {},
    },
    loading: {
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    //单行删除
    del(code) {
      this.$emit('batchDel', [code])
    },
    //批量删除前的验证
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }

      if (data.length > 20) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_max_select_rows') ||
            '最多可选择20行！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.goodsSpecFabriclCode
        })
      }
      return data
    },
  },
}
</script>
